import { DefaultOptions } from "@apollo/client/core";

export const POS_ID: string = '650b63c094e67c588943cc67';
export const bck_host: string = 'bck-prd.elevok.com';
export const bck_url: string = `https://${bck_host}`;
export const AWS_CREDENTIALS: any = {
  region: 'ap-south-1',
  storage: 'elevok-bucket',
};

export const environment = {
  production: true,
  BACKEND_URL: `${bck_url}/graphql`,
  BACKEND_URL_WSS: `wss://${bck_host}/graphql`,
      AUTH_API: 'https://oauth-bck.elevok.com/graphql',
};

/** App origin for asset URLs (empty = same-origin relative paths). */
export const BASE_URL = '';

export const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  },
};